import IndexVendor from '@/modules/vendor/pages/IndexVendor'

export default [
    {
        name: 'vendor.index',
        path: '/vendor',
        component: IndexVendor,
        meta: {
            layout: 'vendor',
            title: 'Acceuil'
        }
    }
]